import { dispatchSwiftCustomEvent } from '~/helpers/events'
import type { Cart, Product } from '~/type/Cart'
import type { OrderStatusProps } from '~/type/Order'

export enum EcommerceEvents {
  /***
   * Evento enviado os eventos são iniciados
   */

  initialized = 'initialized',
  /***
   * Evento enviado quando o produto é adicionado ao carrinho
   */
  addToCart = 'addToCart',
  /**
   * Evento enviado quando o produto é removido do carrinho
   */
  removeFromCart = 'removeFromCart',
  /**
   * Evento enviado quando a compra é finalizada
   */
  orderPlaced = 'orderPlaced',
  /**
   * Evento enviado quando as informações de pagamento são adicionadas/selecionadas
   */
  addPaymentInfo = 'addPaymentInfo',
  /**
   * Evento enviado quando as informações de entrega são adicionadas/selecionadas
   */
  addShippingInfo = 'addShippingInfo',
  /**
   * Evento enviado quando o cliente entra no fluxo de checkout (carrinho)
   */
  beginCheckout = 'beginCheckout',
  /**
   * Evento enviado quando o cliente visualiza um dos passos do checkout
   */
  viewStepCheckout = 'viewStepCheckout',
  /**
   * Evento enviado quando os dados do cliente autenticado existem
   */
  customerData = 'customerData',
  /**
   * Evento enviado quando o carrinho é exibido
   */
  viewCart = 'viewCart',
}

export const useTrackEvents = () => {
  const trackViewCart = (cart: Cart) => {
    dispatchSwiftCustomEvent({
      event: EcommerceEvents.viewCart,
      products: cart.items,
      cart,
    })
  }

  const trackAddToCart = (products: Product[], list: string) => {
    dispatchSwiftCustomEvent({
      event: EcommerceEvents.addToCart,
      products,
      list,
    })
  }

  const trackRemoveFromCart = (products: any, list: string) => {
    dispatchSwiftCustomEvent({
      event: EcommerceEvents.removeFromCart,
      products,
      list,
    })
  }

  const trackPurchase = (order: OrderStatusProps) => {
    const cacheTransactionIdKey = 'order-transaction-id'
    const cacheTransactionIds = JSON.parse(localStorage.getItem(cacheTransactionIdKey) || '[]')

    // Garantir que cacheTransactionIds seja um array
    if (!Array.isArray(cacheTransactionIds)) {
      localStorage.setItem(cacheTransactionIdKey, JSON.stringify([]))
    }

    if (cacheTransactionIds.includes(order.orderId)) {
      console.log(`Order ${order.orderId} already tracked`, order)
      return
    }

    dispatchSwiftCustomEvent({
      event: EcommerceEvents.orderPlaced,
      ecommerData: order,
    })

    const updatedCacheTransactionIds = [...cacheTransactionIds, order.orderId].slice(-8)

    localStorage.setItem(cacheTransactionIdKey, JSON.stringify(updatedCacheTransactionIds))
  }

  const trackAddPaymentInfo = (cart: Cart, paymentType: string | null) => {
    dispatchSwiftCustomEvent({
      event: EcommerceEvents.addPaymentInfo,
      products: cart.items,
      paymentType,
    })
  }

  const trackAddShippingInfo = (products: Product[], shippingTier: string) => {
    dispatchSwiftCustomEvent({
      event: EcommerceEvents.addShippingInfo,
      products,
      shippingTier,
    })
  }

  const trackBeginCheckout = (cart: Cart) => {
    dispatchSwiftCustomEvent({
      event: EcommerceEvents.beginCheckout,
      products: cart.items,
      cart,
    })
  }

  const trackViewtStepCheckout = (cart: Cart, step: string | number) => {
    dispatchSwiftCustomEvent({
      event: EcommerceEvents.viewStepCheckout,
      products: cart.items,
      cart,
      step: step,
    })
  }

  const trackCustomerData = (userData: any) => {
    dispatchSwiftCustomEvent({
      event: EcommerceEvents.customerData,
      userData,
    })
  }

  const trackInitialization = (userData: any) => {
    dispatchSwiftCustomEvent({
      event: EcommerceEvents.initialized,
      userData,
    })
  }

  return {
    trackAddToCart,
    trackRemoveFromCart,
    trackPurchase,
    trackAddPaymentInfo,
    trackAddShippingInfo,
    trackBeginCheckout,
    trackViewtStepCheckout,
    trackCustomerData,
    trackInitialization,
    trackViewCart,
  }
}
